module.exports = __webpack_public_path__ + "static/img/uploading.7faa64e4.gif";